import { createApp } from 'vue';
import VariantListView from './VariantListView.vue';
import i18n from './VariantListView-i18n';

const mountEl = document.getElementById('variant-list-view-app');
if (mountEl) {

        const app = createApp(VariantListView);
        app.use(i18n);
        app.mount(mountEl);

}